module.exports = __webpack_public_path__ + "ce16c7e941cef0f27afda6d1dfd5165c.png";